import React from "react";
import styled from "styled-components";

const LoadingblockOuter = styled.div`
  position: relative;
  margin-bottom: ${(props) => `${props.margin}px`};

  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ${(props) => (props.height ? `${props.height}px` : `56.25%`)};
  }
`;

const LoadingblockInner = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: lightgrey;
  background-size: cover;
  background-position: 50% 50%;
  animation: pulse 1.3s infinite ease-in-out;

  @keyframes pulse {
    0% {
      background-color: rgba(165, 165, 165, 0.1);
    }
    50% {
      background-color: rgba(165, 165, 165, 0.3);
    }
    100% {
      background-color: rgba(165, 165, 165, 0.1);
    }
  }
`;

const LoadingBlock = ({ height = null, margin = 0 }) => {
  return (
    <LoadingblockOuter height={height} margin={margin}>
      <LoadingblockInner></LoadingblockInner>
    </LoadingblockOuter>
  );
};

export default LoadingBlock;
